import type { YYYYMMDD } from '../typings'

import { parseDateString } from '@/server-data'

export const parseDate = (date: YYYYMMDD): Date => parseDateString(date)
